var ModalServiceModule = /** @class */ (function () {
    function ModalServiceModule() {
    }
    return ModalServiceModule;
}());
export { ModalServiceModule };
